
export class GetPlanogramStatesRequest {
  planogramId: string = '';

  constructor(planogramId: string) {
    this.planogramId = planogramId;
  }
}
